<template>
	<appBaseModal v-if="shouldShowModal">	
		<div slot="content">

			<div class="modal__head">
				<div class="modal__head__title">{{maContent.ma4_1_1}}</div>
				<div class="modal__head__subtitle">{{maContent.ma4_1_2}}</div>
			</div>
			<div class="modal__content" @keyup.enter="save">
				<input type="text" v-model="areaTitle" v-bind:placeholder="maContent.ma4_1_3">
				<textarea name="" v-model="areaDesc" id="" cols="30" rows="10" v-bind:placeholder="maContent.ma4_1_4"></textarea>
				<button @click="save" class="btn primary">Continue</button>
			</div>

		</div>
	</appBaseModal>
</template>

<script>
	
    import BaseModal from './BaseModal';
	export default {
		components : {
			appBaseModal : BaseModal
		},
		data(){
			return {
				compName : 'TitleDescModal',
				areaTitle : '',
				areaDesc : '',
				
			}
		},
		methods : {
			save(){
				if(this.areaTitle.includes('&')){
					this.$toasted.error('Please do not use & symbol', {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                    })
					
					return;
				}
				
				
				if(this.areaTitle.length < 1){
					this.$toasted.error('You should have an area title of more than 5 characters', {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                    })
					
					return;
				}

				if(this.areaDesc.includes('&')){
					this.$toasted.error('Please do not use & symbol', {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                    })
					
					return;
				}

				if(this.areaDesc.length < 5){
					this.$toasted.error('You should have an area description of more than 5 characters', {
                        theme: 'bubble',
                        position: 'bottom-center',
                        duration: 5000
                    })
					return;
				}

				if(this.errMessage){
					this.$toasted.clear();
				}
				
				this.$store.commit('areaCreator', {
					areaTitle : this.areaTitle,
					areaDescription : this.areaDesc
				})
				this.$store.commit('closeModal', '');
				this.$store.commit('navigateToAreaDetails');
				this.$store.commit('centerPolygon');
				this.areaTitle = "";
				this.areaDesc = "";
			
				// google.maps.event.trigger(, "resize");
			}
		},
		computed : {
			shouldShowModal(){
				return this.$store.getters.getModalActive.modalName === this.compName
			},
			maContent(){
     			 return this.$store.getters.getBuildData;
    },
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/common/Modals/TitleDescModal.vue